var map = {
	"./check-icon.svg": 811,
	"./data-view-icon.svg": 812,
	"./plus-icon.svg": 688,
	"./suggest-relationship-icons.stories": 813,
	"./suggest-relationship-icons.stories.jsx": 813,
	"./suggest-relationship-left-panel": 492,
	"./suggest-relationship-left-panel.jsx": 492,
	"./suggest-relationship-line": 431,
	"./suggest-relationship-line.jsx": 431,
	"./suggest-relationship-line.scss": 810,
	"./suggest-relationship.scss": 687,
	"./table-icon.svg": 814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 544;